// extracted by mini-css-extract-plugin
export default {"wrapper":"JackpotLayerGameTile_wrapper__6Jfrs","container":"JackpotLayerGameTile_container__Sgwtq"};